module.exports = {
	defaultTitle: 'Jorge Adolfo',
	logo: 'https://portfolio.jorgeadolfo.com/favicon/favicon-512.png',
	author: 'Jorge Adolfo',
	url: 'https://portfolio.jorgeadolfo.com',
	legalName: 'Jorge Adolfo',
	defaultDescription: 'I’m Jorge Adolfo and I’m a FullStack & Devops engineer!',
	socialLinks: {
		twitter: 'http://www.twitter.com/g3org3dev',
		github: 'https://github.com/g3org3',
		linkedin: 'https://www.linkedin.com/in/jorgeadolfo/',
	},
	googleAnalyticsID: '',
	themeColor: '#6b63ff',
	backgroundColor: '#6b63ff',
	social: {
		facebook: 'appId',
		twitter: '@g3org3dev',
	},
	address: {
		city: 'City',
		region: 'Region',
		country: 'Country',
		zipCode: 'ZipCode',
	},
	contact: {
		email: 'email',
		phone: 'phone number',
	},
	foundingDate: '2019',
	recaptcha_key: '6LfI5boUAAAAANaEcRUnESj68eFGmVzV0XVXS0Cx'
}
